import * as types from './constants';

export const initialState = {
  id: null,
  loading: false,
  errors_api: {}
};

const actions = {

  // Get Analytics Links Report
  [types.GENERATE_ANALYTICS_LINKS_REPORT_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GENERATE_ANALYTICS_LINKS_REPORT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      ...payload
    };

    return { ...data };
  },

  [types.GENERATE_ANALYTICS_LINKS_REPORT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GENERATE_ANALYTICS_LINKS_REPORT_RESET]: state => {
    const data = {
      ...state,
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

